/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import {
  ForgotUsername,
  RowForgotUsername,
  ColForgotUsername,
  LayoutForgotUsername,
} from 'fpay-ui';
import { fogEmail } from '@helpers';

const OperationLoguinTable = ({ dataHeader, dataBody, properity = [] }) => (
  <LayoutForgotUsername>
    <ForgotUsername>
      {dataHeader && (
        <RowForgotUsername header>
          {dataHeader?.map((el, k) => (
            <ColForgotUsername key={`key-header-${k}`} header {...properity[k]}>
              {el}
            </ColForgotUsername>
          ))}
        </RowForgotUsername>
      )}

      {dataBody &&
        dataBody?.map((el, i) => (
          <RowForgotUsername key={i}>
            <ColForgotUsername>{el[0]}</ColForgotUsername>
            <ColForgotUsername>{fogEmail(el[1].email)}</ColForgotUsername>
          </RowForgotUsername>
        ))}
    </ForgotUsername>
  </LayoutForgotUsername>
);

export default OperationLoguinTable;
